module.exports = __webpack_public_path__ + "img/marking_scaffold_button_updated.7d548c74.png";